import React, { useState, useEffect } from "react";
import { User, Phone, Mail, Building2 } from "lucide-react";
import { updateProfile } from "../../apiCalls/user";

const SaveProfile = ({ saveData, labId, isEditing, setIsEditing }) => {
  const [profileData, setProfileData] = useState({
    labName: "", ownerName: "", labEmail: "", mobileNumber: "", alternatePhone: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit,   setIsSubmit]   = useState(false);

  useEffect(() => {
    if (saveData) setProfileData((p) => ({ ...p, ...saveData }));
  }, [saveData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfileData((p) => ({ ...p, [name]: value }));
    if (formErrors[name]) setFormErrors((e) => ({ ...e, [name]: "" }));
  };

  const validate = (v) => {
    const err = {};
    if (!v.labName)   err.labName   = "Lab name is required";
    if (!v.ownerName) err.ownerName = "Owner name is required";
    return err;
  };

  const handleSave = (e) => {
    e.preventDefault();
    const err = validate(profileData);
    setFormErrors(err);
    setIsSubmit(true);
  };

  const handleClick = async () => {
    const { labName, ownerName, labEmail, mobileNumber, alternatePhone } = profileData;
    await updateProfile({ labName, ownerName, labEmail, mobileNumber, alternatePhone }, labId);
    setIsEditing(false);
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) handleClick();
  }, [formErrors]);

  const fields = [
    { name: "labName",       label: "Lab Name",       type: "text",  icon: <Building2 size={13} />, required: true  },
    { name: "ownerName",     label: "Owner Name",     type: "text",  icon: <User      size={13} />, required: true  },
    { name: "labEmail",      label: "Email",          type: "email", icon: <Mail      size={13} />, required: false },
    { name: "mobileNumber",  label: "Primary Phone",  type: "tel",   icon: <Phone     size={13} />, required: false },
    { name: "alternatePhone",label: "Alternate Phone",type: "tel",   icon: <Phone     size={13} />, required: false },
  ];

  return (
    <div className="form-card h-100">
      <div className="form-card-header">
        <h5 className="form-card-title">
          <User size={15} /> Basic Information
        </h5>
        {isEditing && (
          <span style={{ fontSize: "0.72rem", color: "var(--gray-400)" }}>* required</span>
        )}
      </div>

      <div className="form-card-body">
        {fields.map((f) => (
          <div className="field" key={f.name}>
            <label className="field-label">
              {f.icon} {f.label} {f.required && <span className="req">*</span>}
            </label>
            <input
              type={f.type}
              name={f.name}
              value={profileData[f.name] || ""}
              onChange={handleInputChange}
              disabled={!isEditing}
              className={`field-input ${formErrors[f.name] ? "is-error" : ""}`}
              placeholder={isEditing ? `Enter ${f.label.toLowerCase()}` : "—"}
            />
            {formErrors[f.name] && (
              <span className="field-error">{formErrors[f.name]}</span>
            )}
          </div>
        ))}

        {isEditing && (
          <button className="app-btn app-btn--primary" onClick={handleSave} style={{ marginTop: "0.5rem" }}>
            <User size={14} /> Save Basic Info
          </button>
        )}
      </div>
    </div>
  );
};

export default SaveProfile;
